import { render } from "./LyricsSection.vue?vue&type=template&id=4f3ae98d&scoped=true"
import script from "./LyricsSection.vue?vue&type=script&lang=js"
export * from "./LyricsSection.vue?vue&type=script&lang=js"

import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css?vue&type=style&index=0&lang=css"
import "./LyricsSection.vue?vue&type=style&index=1&id=4f3ae98d&scoped=true&lang=css"

import exportComponent from "/Users/gabrielvoirol/git_projects/df_wpheadless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3ae98d"]])

export default __exports__